/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_ItemsInputs */

const cs_builder_grid_items = /** @type {(inputs: Builder_Grid_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky mřížky`)
};

const en_builder_grid_items = /** @type {(inputs: Builder_Grid_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid items`)
};

/**
* | output |
* | --- |
* | "Grid items" |
*
* @param {Builder_Grid_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_items = /** @type {((inputs?: Builder_Grid_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_items(inputs)
	return cs_builder_grid_items(inputs)
});